import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import { Run } from '../types/backend-dto-types';
import useGetFetchConfig from '../useGetFetchConfig';

export const useGetMatterRuns = (matterId: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<Run[]>(
    [QueryEntity.Runs, matterId],
    () => {
      return fetch(`${APIBaseChronos}/api/matters/${matterId}/runs`, fetchConfigGET).then((res) => {
        return res.json();
      });
    },
    {
      enabled: !!matterId,
      refetchOnWindowFocus: false,
    },
  );
};
